import React from 'react';
import { Modal } from 'react-bootstrap';
import '../../../assets/css/dashboard.css';
import FeeForm from '../forms/feeForm/FeeFormLogic';

const Tax = (props) => {
	return (
		<div>
			<Modal {...props} size="md" aria-labelledby="contained-modal-title-vcenter" centered>
				<Modal.Header closeButton>
					<Modal.Title>
						<h5 className="text-grey text-center">Add Fees</h5>
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<FeeForm refetch={props.refetch} />
				</Modal.Body>
			</Modal>
		</div>
	);
};

export default Tax;
